import { getOne } from 'api/cloudsave/cloudsaveApi';
import { storageUnitCache } from './cache/storageUnitCacheIndexedDB';
import type { StorageUnit } from 'store/storageunits/types';

/**
 * Downloads a file from the server and caches it locally for offline use.
 * This is the single source of truth for downloading and caching files.
 *
 * @param fileId - The ID of the file to download
 * @returns The downloaded StorageUnit with fileData
 * @throws Error if the file has no data or download fails
 */
export async function downloadAndCache(fileId: string): Promise<StorageUnit> {
  const { parsedBody } = await getOne(fileId);

  if (!parsedBody?.fileData) {
    throw new Error('No file data available');
  }

  // Cache the file for offline use
  const cached = await storageUnitCache.setOne(parsedBody);

  return cached;
}
